import { render, staticRenderFns } from "./ResultsViewOptions.vue?vue&type=template&id=5907f82c&"
import script from "./ResultsViewOptions.vue?vue&type=script&lang=ts&"
export * from "./ResultsViewOptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports